﻿import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { EntityCreateRequest, EntityResponse } from "../models";
import { queryKeys } from "../queryKeys";
import { AxiosError } from "axios";
import { axiosInstance } from "../../utils";

export function useClientEntityCreate() {
    const axios = axiosInstance(),
        queryClient = useQueryClient();

    const toast = useToast();

    return useMutation({
        mutationFn: (request: { clientId: string; data: EntityCreateRequest }) =>
            axios.post<EntityResponse>(`api/Clients/${request.clientId}/entities`, request.data).then(response => response.data),
        onSuccess: async (data, variables) => {
            toast({
                title: "Entity Created",
                description: "Entity was successfully created!",
                status: "success",
                isClosable: true,
                duration: 5000,
            });
            await queryClient.invalidateQueries(queryKeys.clients.entities(variables.clientId).queryKey);
            await queryClient.setQueryData(queryKeys.clients.entityById(variables.clientId, data.id).queryKey, data);
        },
        onError: (error: any) => {
            const axiosError = error as AxiosError;

            if (error?.response?.data?.errors?.name?.length) {
                toast({
                    title: "Changes not saved",
                    description: error.response.data.errors.name.join(", "),
                    status: "error",
                    isClosable: true,
                    duration: null,
                });

                return;
            }

            toast({
                title: "Changes not saved",
                description: `[${axiosError.request.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
